// extracted by mini-css-extract-plugin
export default {"dropmenu":"drop_dropmenu__dyje-","ddmenu":"drop_ddmenu__G4mq9"};